import BaseLink, { BaseLinkPropTypes } from './BaseLink';

export default BaseLink;
export type { BaseLinkPropTypes };
